import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['kind', 'hours', 'events', 'mode', 'weekly']

  connect () {
    this.toggle()
    this.toggleMode()
  }

  toggle () {
    const eventMode = this.hasKindTarget && this.kindTarget.value === 'event'
    if (this.hasHoursTarget) this.hoursTarget.classList.toggle('hidden', eventMode)
    if (this.hasEventsTarget) this.eventsTarget.classList.toggle('hidden', !eventMode)
  }

  toggleMode () {
    if (!this.hasModeTarget || !this.hasWeeklyTarget) return
    this.weeklyTarget.classList.toggle('hidden', this.modeTarget.value === 'always_open')
  }
}
